// This is utils enum for use both modules and apps scope
export var AiChangeResourceType;

(function (AiChangeResourceType) {
  AiChangeResourceType["Question"] = "question";
  AiChangeResourceType["Section"] = "section";
  AiChangeResourceType["Heading"] = "heading";
})(AiChangeResourceType || (AiChangeResourceType = {}));